module.exports = __webpack_public_path__ + "static/media/stjerne_brown-min.45e7f997.png";